import {
  AddBookmarks,
  CreateCollection,
  DeleteBookmarks,
  DeleteCollection,
  EditCollection,
  GetCollectionBookmarks,
  GetContentCollections,
  GetUserCollections,
  reqAddBookmarks,
  reqCreateCollection,
  reqDeleteBookmarks,
  ReqDeleteBookmarksPayload,
  reqDeleteCollection,
  reqEditCollection,
  reqGetCollectionBookmarks,
  reqGetContentCollections,
  reqGetUserCollections,
} from '@weblite/ts-action/bookmark'
import { request } from '$setup/ws'

export async function createCollection(title: string) {
  const res = await request<CreateCollection>(reqCreateCollection({ title }))
  return !res.error
}

export async function getCollections() {
  const res = await request<GetUserCollections>(reqGetUserCollections({}))
  return res.payload?.collections ?? []
}

export async function getCollectionBookmarks(collectionTitle: string) {
  const res = await request<GetCollectionBookmarks>(
    reqGetCollectionBookmarks({ collectionTitle }),
  )
  return res.payload?.bookmarks ?? []
}

export async function editCollection(
  collectionTitle: string,
  newTitle: string,
) {
  const res = await request<EditCollection>(
    reqEditCollection({ collectionTitle, newTitle }),
  )
  return !res.error
}

export async function deleteCollection(collectionTitle: string) {
  const res = await request<DeleteCollection>(
    reqDeleteCollection({ collectionTitle }),
  )
  return !res.error
}

export async function addBookmark(
  contentUri: string,
  cover: string,
  collectionTitles: string[],
) {
  const res = await request<AddBookmarks>(
    reqAddBookmarks({ contentUri, collectionTitles, cover }),
  )
  return res.payload
}

export async function deleteBookmark(
  bookmarks: ReqDeleteBookmarksPayload['bookmarks'],
) {
  const res = await request<DeleteBookmarks>(reqDeleteBookmarks({ bookmarks }))
  return !res.error
}

export async function getContentCollection(contentUri: string) {
  const res = await request<GetContentCollections>(
    reqGetContentCollections({ contentUri }),
  )

  return res.payload.titles
}
